import React from 'react';
import {
	AdvancedMarker,
	InfoWindow,
	Pin,
	useAdvancedMarkerRef
} from '@vis.gl/react-google-maps';

const NoteMarker = props => {
	const [markerRef, marker] = useAdvancedMarkerRef();

	return (
		<div>
			<AdvancedMarker
				ref={markerRef}
			position={{
				lat: props.note.location.latitude,
				lng: props.note.location.longitude
			}}
			clickable={true}
			onClick={props.onClick}
		>
			<Pin />

			{props.openNoteKey === props.note.key && (
				<InfoWindow
					anchor={marker}
					onCloseClick={props.onCloseClickInfoWindow}
				>
					<div>
						{ props.note.address && <p style={{ fontWeight: 'bold', color: 'rgb(66, 66, 66)' }}>Adres (ter hoogte van):<br/>{props.note.address}</p> }
						<h5>{props.note.description}</h5>
						{props.note.isArchived ? (
							<button className="btn btn-sm btn-success btn-outline" title="Herstellen - opnieuw zichtbaar in de app" data-toggle="tooltip"
								onClick={props.unarchiveLog}>Opnieuw zichtbaar maken
							</button>
						) : (
							<button className="btn btn-sm btn-warning btn-outline" title="Archiveren - niet meer zichtbaar in de app" data-toggle="tooltip"
								onClick={props.archiveLog}>Archiveren (onzichtbaar maken)
							</button>
						)}
						<button
							style={{ marginLeft: 6 }}
							className="btn btn-sm btn-outline-danger"
							onClick={props.onClickDeleteNote}
						>
							Verwijderen
						</button>
					</div>
				</InfoWindow>
			)}
		</AdvancedMarker>
	</div>)
}

export default NoteMarker;
